import { useQuery } from '@tanstack/react-query';
import ScheduleSection from './ScheduleSection';

const IntroSection = ({ id }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const { data } = useQuery({
		queryKey: ['class', id],
		queryFn: async () => {
			const res = await fetch(`${API_URL}/bbs/ajax.get_class.php?cl_id=${id}`);
			return res.json();
		}
	});
	const item = data?.item ?? null;
	
	return (
		<div className="space-y-8">
			<div>
				<h3 className="text-2xl font-bold text-gray-900 mb-4">수업 소개</h3>
				<p className="text-lg text-gray-700 leading-relaxed">{item?.description}</p>
			</div>
			<div>
				<h3 className="text-2xl font-bold text-gray-900 mb-4">스케쥴</h3>
				<ScheduleSection classId={id}/>
			</div>
		</div>
	);
};

export default IntroSection;